import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=2dbaab7d&scoped=true&"
import script from "./FeedBack.vue?vue&type=script&lang=js&"
export * from "./FeedBack.vue?vue&type=script&lang=js&"
import style1 from "./FeedBack.vue?vue&type=style&index=1&id=2dbaab7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbaab7d",
  null
  
)

export default component.exports